import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PostgrestBuilder } from './types';
import PostgrestFilterBuilder from './PostgrestFilterBuilder';

var PostgrestQueryBuilder = /*#__PURE__*/function (_PostgrestBuilder) {
  _inherits(PostgrestQueryBuilder, _PostgrestBuilder);

  var _super = _createSuper(PostgrestQueryBuilder);

  function PostgrestQueryBuilder(url) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        schema = _ref.schema,
        fetch = _ref.fetch,
        shouldThrowOnError = _ref.shouldThrowOnError;

    _classCallCheck(this, PostgrestQueryBuilder);

    _this = _super.call(this, {
      fetch: fetch,
      shouldThrowOnError: shouldThrowOnError
    });
    _this.url = new URL(url);
    _this.headers = Object.assign({}, headers);
    _this.schema = schema;
    return _this;
  }
  /**
   * Performs vertical filtering with SELECT.
   *
   * @param columns  The columns to retrieve, separated by commas.
   * @param head  When set to true, select will void data.
   * @param count  Count algorithm to use to count rows in a table.
   */


  _createClass(PostgrestQueryBuilder, [{
    key: "select",
    value: function select() {
      var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$head = _ref2.head,
          head = _ref2$head === void 0 ? false : _ref2$head,
          _ref2$count = _ref2.count,
          count = _ref2$count === void 0 ? null : _ref2$count;

      this.method = 'GET'; // Remove whitespaces except when quoted

      var quoted = false;
      var cleanedColumns = columns.split('').map(function (c) {
        if (/\s/.test(c) && !quoted) {
          return '';
        }

        if (c === '"') {
          quoted = !quoted;
        }

        return c;
      }).join('');
      this.url.searchParams.set('select', cleanedColumns);

      if (count) {
        this.headers['Prefer'] = "count=".concat(count);
      }

      if (head) {
        this.method = 'HEAD';
      }

      return new PostgrestFilterBuilder(this);
    }
  }, {
    key: "insert",
    value: function insert(values) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$upsert = _ref3.upsert,
          upsert = _ref3$upsert === void 0 ? false : _ref3$upsert,
          onConflict = _ref3.onConflict,
          _ref3$returning = _ref3.returning,
          returning = _ref3$returning === void 0 ? 'representation' : _ref3$returning,
          _ref3$count = _ref3.count,
          count = _ref3$count === void 0 ? null : _ref3$count;

      this.method = 'POST';
      var prefersHeaders = ["return=".concat(returning)];
      if (upsert) prefersHeaders.push('resolution=merge-duplicates');
      if (upsert && onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
      this.body = values;

      if (count) {
        prefersHeaders.push("count=".concat(count));
      }

      if (this.headers['Prefer']) {
        prefersHeaders.unshift(this.headers['Prefer']);
      }

      this.headers['Prefer'] = prefersHeaders.join(',');

      if (Array.isArray(values)) {
        var columns = values.reduce(function (acc, x) {
          return acc.concat(Object.keys(x));
        }, []);

        if (columns.length > 0) {
          var uniqueColumns = _toConsumableArray(new Set(columns)).map(function (column) {
            return "\"".concat(column, "\"");
          });

          this.url.searchParams.set('columns', uniqueColumns.join(','));
        }
      }

      return new PostgrestFilterBuilder(this);
    }
    /**
     * Performs an UPSERT into the table.
     *
     * @param values  The values to insert.
     * @param onConflict  By specifying the `on_conflict` query parameter, you can make UPSERT work on a column(s) that has a UNIQUE constraint.
     * @param returning  By default the new record is returned. Set this to 'minimal' if you don't need this value.
     * @param count  Count algorithm to use to count rows in a table.
     * @param ignoreDuplicates  Specifies if duplicate rows should be ignored and not inserted.
     */

  }, {
    key: "upsert",
    value: function upsert(values) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          onConflict = _ref4.onConflict,
          _ref4$returning = _ref4.returning,
          returning = _ref4$returning === void 0 ? 'representation' : _ref4$returning,
          _ref4$count = _ref4.count,
          count = _ref4$count === void 0 ? null : _ref4$count,
          _ref4$ignoreDuplicate = _ref4.ignoreDuplicates,
          ignoreDuplicates = _ref4$ignoreDuplicate === void 0 ? false : _ref4$ignoreDuplicate;

      this.method = 'POST';
      var prefersHeaders = ["resolution=".concat(ignoreDuplicates ? 'ignore' : 'merge', "-duplicates"), "return=".concat(returning)];
      if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
      this.body = values;

      if (count) {
        prefersHeaders.push("count=".concat(count));
      }

      if (this.headers['Prefer']) {
        prefersHeaders.unshift(this.headers['Prefer']);
      }

      this.headers['Prefer'] = prefersHeaders.join(',');
      return new PostgrestFilterBuilder(this);
    }
    /**
     * Performs an UPDATE on the table.
     *
     * @param values  The values to update.
     * @param returning  By default the updated record is returned. Set this to 'minimal' if you don't need this value.
     * @param count  Count algorithm to use to count rows in a table.
     */

  }, {
    key: "update",
    value: function update(values) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$returning = _ref5.returning,
          returning = _ref5$returning === void 0 ? 'representation' : _ref5$returning,
          _ref5$count = _ref5.count,
          count = _ref5$count === void 0 ? null : _ref5$count;

      this.method = 'PATCH';
      var prefersHeaders = ["return=".concat(returning)];
      this.body = values;

      if (count) {
        prefersHeaders.push("count=".concat(count));
      }

      if (this.headers['Prefer']) {
        prefersHeaders.unshift(this.headers['Prefer']);
      }

      this.headers['Prefer'] = prefersHeaders.join(',');
      return new PostgrestFilterBuilder(this);
    }
    /**
     * Performs a DELETE on the table.
     *
     * @param returning  If `true`, return the deleted row(s) in the response.
     * @param count  Count algorithm to use to count rows in a table.
     */

  }, {
    key: "delete",
    value: function _delete() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$returning = _ref6.returning,
          returning = _ref6$returning === void 0 ? 'representation' : _ref6$returning,
          _ref6$count = _ref6.count,
          count = _ref6$count === void 0 ? null : _ref6$count;

      this.method = 'DELETE';
      var prefersHeaders = ["return=".concat(returning)];

      if (count) {
        prefersHeaders.push("count=".concat(count));
      }

      if (this.headers['Prefer']) {
        prefersHeaders.unshift(this.headers['Prefer']);
      }

      this.headers['Prefer'] = prefersHeaders.join(',');
      return new PostgrestFilterBuilder(this);
    }
  }]);

  return PostgrestQueryBuilder;
}(PostgrestBuilder);

export { PostgrestQueryBuilder as default };